import { PaymentCard } from '@pages/cost-centers/components';
import { useInfoCenterPublic } from '@content-api/provider';
import { Typography, Button, toast } from '@ui/components';
import { DataTransfer } from '@ui/components/icons';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

export const WireTransferMethod: FC<{
  costCenterAccountNumber: string;
  onClick?: () => void;
  open?: boolean;
}> = ({ open, costCenterAccountNumber, onClick }) => {
  const { t } = useTranslation();

  const { getContactUs } = useInfoCenterPublic();
  const { data: contactUs } = useQuery({
    queryKey: ['content-api', 'contact-us'],
    queryFn: () => getContactUs(),
  });

  return (
    <div className="flex flex-col gap-3">
      {open && (
        <div className="flex flex-wrap gap-2">
          <Typography variant="labelMediumBold" element="span">
            {t('COST_CENTER.ACCOUNT_TOP_UPS.WIRE_TRANSFER_LABEL')}
          </Typography>
          <Typography variant="labelMediumBook" className="text-weak" element="span">
            {t('COST_CENTER.ACCOUNT_TOP_UPS.WIRE_TRANSFER_DATA_LABEL_MESSAGE')}
          </Typography>
        </div>
      )}
      <PaymentCard
        subtitle={t('COST_CENTER.ACCOUNT_TOP_UPS.WIRE_TRANSFER_SUBTITLE')}
        title={t('COST_CENTER.ACCOUNT_TOP_UPS.WIRE_TRANSFER_TITLE')}
        icon={<DataTransfer />}
        onClick={onClick}
      />
      {open && (
        <div className="space-y-2">
          <Typography variant="labelSmallBook" className="text-weak" element="h6">
            {t('COST_CENTER.ACCOUNT_TOP_UPS.WIRE_TRANSFER_DATA_TITLE')}
          </Typography>
          {costCenterAccountNumber ? (
            <div>
              <Typography variant="labelMediumBook" element="span">
                {t('COST_CENTER.ACCOUNT_TOP_UPS.WIRE_TRANSFER_INFO_LINE_1', {
                  address: contactUs?.data.address,
                })}
              </Typography>
              <div className="flex items-center gap-2">
                <Typography variant="labelMediumBook" element="span">
                  {t('COST_CENTER.ACCOUNT_TOP_UPS.WIRE_TRANSFER_INFO_LINE_2')}
                </Typography>
                <Typography variant="labelMediumBook" element="span">
                  {costCenterAccountNumber}
                </Typography>
                <Button
                  onClick={() => {
                    navigator.clipboard.writeText(costCenterAccountNumber);
                    toast.success(t('COST_CENTER.ACCOUNT_TOP_UPS.COPY_SUCCESS'));
                  }}
                  className="inline-block"
                  variant="link"
                  type="button"
                  size="small"
                >
                  <Typography variant="labelMediumBook">
                    {t('COST_CENTER.ACCOUNT_TOP_UPS.COPY')}
                  </Typography>
                </Button>
              </div>
              <Typography variant="labelMediumBook" element="span">
                {t('COST_CENTER.ACCOUNT_TOP_UPS.WIRE_TRANSFER_INFO_LINE_3')}
              </Typography>
            </div>
          ) : (
            <Typography variant="labelMediumBook">
              {t('COST_CENTER.ACCOUNT_TOP_UPS.ACCOUNT_NUMBER_NOT_READY_YET')}
            </Typography>
          )}
        </div>
      )}
    </div>
  );
};
